// src/Pages/InviteHandler.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const InviteHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const url = new URL(window.location.href);
    const inviteEmail = url.searchParams.get("invite_email");
    const inviteId = url.searchParams.get("invite_id");

    if (inviteEmail && inviteId) {
      console.log("Invite detected — clearing tokens...");

      // Clear tokens/sessions
      localStorage.removeItem("authToken");
      sessionStorage.clear();

      // Optionally save invite info
      localStorage.setItem("inviteEmail", inviteEmail);
      localStorage.setItem("inviteId", inviteId);

      // Redirect user
      navigate("/dashboard", { replace: true });
    }
  }, [navigate]);

  return null; // no UI
};

export default InviteHandler;
